import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  DialogTitle,
  DialogActions,
  Snackbar,
  Alert,
  LinearProgress,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Badge,
  Tooltip,
  Fade,
  InputAdornment,
  Autocomplete,
  Popover,
  Divider,
  Card,
  CardContent,
  CardActions,
  Collapse,
  DialogContent,
  Switch,
  FormGroup,
} from '@mui/material';
import Slide from '@mui/material/Slide';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AddIcon from '@mui/icons-material/Add';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import axios from '../../axios';
import './animation.css';

const HeaderPaper = styled(Paper)(({ theme }) => ({
  background: 'linear-gradient(135deg, #134e5e 0%, #71b280 100%)',
  borderRadius: '12px',
  padding: '16px 24px',
  marginBottom: '16px',
  boxShadow: '0 4px 20px rgba(19, 78, 94, 0.3)',
}));

// Full Row Card styled component
const FullRowCard = styled(Paper)(({ theme }) => ({
  borderRadius: '12px',
  border: '1px solid #e8ecf0',
  padding: theme.spacing(2),
  marginBottom: theme.spacing(1.5),
  transition: 'all 0.2s ease',
  '&:hover': {
    boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
    borderColor: '#c0c8d0',
  },
}));

// Grid Card styled component
const GridCard = styled(Card)(({ theme }) => ({
  borderRadius: '12px',
  border: '1px solid #e8ecf0',
  height: '100%',
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
  },
}));

// FAQ Row Item Component
const FAQRowItem = ({ row, index, onRowChange, onRemove, isRemovable, rowError }) => (
  <Box
    sx={{
      border: `1px solid ${rowError ? '#d32f2f' : '#e8ecf0'}`,
      borderRadius: 2,
      p: 2,
      mb: 1.5,
      bgcolor: rowError ? 'rgba(211, 47, 47, 0.02)' : 'transparent',
      transition: 'border-color 0.2s ease',
    }}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
      <Typography variant="subtitle2" fontWeight={600} color="primary">
        Question {index + 1}
      </Typography>
      {isRemovable && (
        <Tooltip title="Remove question">
          <IconButton color="error" size="small" onClick={() => onRemove(index)}>
            <RemoveCircleOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Stack>

    <Stack spacing={1.5}>
      <TextField
        label="Question"
        value={row.question}
        onChange={(e) => onRowChange(index, 'question', e.target.value)}
        fullWidth
        size="small"
        required
        error={rowError && !row.question.trim()}
        helperText={rowError && !row.question.trim() ? 'Question is required' : ''}
        placeholder="Enter your question here..."
      />
      <TextField
        label="Answer"
        value={row.answer}
        onChange={(e) => onRowChange(index, 'answer', e.target.value)}
        fullWidth
        multiline
        rows={2}
        size="small"
        required
        error={rowError && !row.answer.trim()}
        helperText={rowError && !row.answer.trim() ? 'Answer is required' : ''}
        placeholder="Enter the answer here..."
      />
    </Stack>
  </Box>
);

const FAQMaster = () => {
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [open, setOpen] = useState(false);
  const [openAlert, setopenAlert] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [operation, setOperation] = useState('Add');
  const [alertType, setAlertType] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');
  const [openLoader, setOpenLoader] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [viewMode, setViewMode] = useState('list');
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [activeFilter, setActiveFilter] = useState({ label: 'Active', value: 'Y' });
  const [productFilter, setProductFilter] = useState(null);
  const [expandedFaqId, setExpandedFaqId] = useState(null);
  const [faqDetailMap, setFaqDetailMap] = useState({});

  const [faqData, setFaqData] = useState([]);
  const [productList, setProductList] = useState([]);
  const [IdToDelete, setIdToDelete] = useState(null);
  const [editID, setEditID] = useState();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [faqHeaderStatus, setFaqHeaderStatus] = useState('Y');
  const [faqRows, setFaqRows] = useState([{ question: '', answer: '' }]);
  const [errors, setErrors] = useState({ selectedProduct: false, faqRows: false });
  const [helperTexts, setHelperTexts] = useState({ selectedProduct: '', faqRows: '' });
  const [rowErrors, setRowErrors] = useState([false]);

  const getProductDisplayText = useCallback((product) => {
    if (!product) return '';
    return `${product.ProductName || ''} (${product.ShortCode || ''})`;
  }, []);

  const getQuestionCountText = useCallback((count) => {
    const questionCount = Number(count || 0);
    return `${questionCount} ${questionCount === 1 ? 'question' : 'questions'}`;
  }, []);

  const getAvailableProducts = useCallback(() => {
    const usedProductIds = faqData.map((item) => item.ProductID);
    return productList.filter((product) => !usedProductIds.includes(product.ProductID));
  }, [faqData, productList]);

  const getProductOptions = useCallback(() => {
    if (operation === 'Edit' && selectedProduct) {
      const available = getAvailableProducts();
      const currentProductExists = available.some((p) => p.ProductID === selectedProduct.ProductID);
      if (!currentProductExists) {
        const isUsedByOther = faqData.some(
          (item) => item.ProductID === selectedProduct.ProductID && item.HeaderID !== editID
        );
        if (!isUsedByOther) {
          return [selectedProduct, ...available];
        }
        return available;
      }
      return available;
    }
    return getAvailableProducts();
  }, [operation, selectedProduct, getAvailableProducts, faqData, editID]);

  useEffect(() => {
    getAllFAQ();
    getActiveProducts();
  }, []);

  const getActiveProducts = async () => {
    try {
      const res = await axios.instance.get('/GetallActiveProduct', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setProductList(res.data || []);
    } catch (error) {
      console.error('Error fetching active products:', error);
    }
  };

  const getAllFAQ = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/getAllFAQ', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setFaqData(res.data || []);
    } catch (error) {
      console.error('Error fetching FAQ:', error);
    } finally {
      setOpenLoader(false);
    }
  };

  const InsertFAQHeader = async (headerPayload) => {
    const res = await axios.instance.post('/InsertFAQHeader', headerPayload, {
      headers: { Authorization: tokent, 'Content-Type': 'application/json' },
    });
    return res.data && res.data[0] ? res.data[0].HeaderID : null;
  };

  const InsertFAQDetail = async (detailPayload) => {
    await axios.instance.post('/InsertFAQDetail', detailPayload, {
      headers: { Authorization: tokent, 'Content-Type': 'application/json' },
    });
  };

  const UpdateFAQHeader = async (headerId, headerPayload) => {
    await axios.instance.put(`/UpdateFAQHeader/${headerId}`, headerPayload, {
      headers: { Authorization: tokent, 'Content-Type': 'application/json' },
    });
  };

  const DeleteFAQDetailsByHeaderId = async (headerId) => {
    await axios.instance.delete(`/DeleteFAQDetailsByHeaderId/${headerId}`, {
      headers: { Authorization: tokent, 'Content-Type': 'application/json' },
    });
  };

  const DeleteFAQHeader = async (headerId) => {
    await axios.instance.delete(`/DeleteFAQHeader/${headerId}`, {
      headers: { Authorization: tokent, 'Content-Type': 'application/json' },
    });
  };

  const resetFields = useCallback(() => {
    setSelectedProduct(null);
    setFaqHeaderStatus('Y');
    setFaqRows([{ question: '', answer: '' }]);
    setRowErrors([false]);
    setErrors({ selectedProduct: false, faqRows: false });
    setHelperTexts({ selectedProduct: '', faqRows: '' });
  }, []);

  const handleFaqRowChange = useCallback((index, field, value) => {
    setFaqRows((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
    setRowErrors((prev) => {
      const next = [...prev];
      next[index] = false;
      return next;
    });
  }, []);

  const addFaqRow = useCallback(() => {
    setFaqRows((prev) => [...prev, { question: '', answer: '' }]);
    setRowErrors((prev) => [...prev, false]);
  }, []);

  const removeFaqRow = useCallback((index) => {
    setFaqRows((prev) => prev.filter((_, i) => i !== index));
    setRowErrors((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const validateForm = useCallback(() => {
    let isValid = true;
    const newErrors = { selectedProduct: false, faqRows: false };
    const newHelperTexts = { selectedProduct: '', faqRows: '' };
    const newRowErrors = [];

    if (!selectedProduct) {
      newErrors.selectedProduct = true;
      newHelperTexts.selectedProduct = 'Please select a product';
      isValid = false;
    }

    if (operation === 'Add' && selectedProduct) {
      const isProductUsed = faqData.some((item) => item.ProductID === selectedProduct.ProductID);
      if (isProductUsed) {
        newErrors.selectedProduct = true;
        newHelperTexts.selectedProduct = 'This product already has FAQ entries';
        isValid = false;
      }
    }

    if (operation === 'Edit' && selectedProduct && editID) {
      const isUsedByOther = faqData.some(
        (item) => item.ProductID === selectedProduct.ProductID && item.HeaderID !== editID
      );
      if (isUsedByOther) {
        newErrors.selectedProduct = true;
        newHelperTexts.selectedProduct = 'This product already has FAQ entries';
        isValid = false;
      }
    }

    const hasValidRows = faqRows.some((row) => row.question.trim() && row.answer.trim());
    if (!hasValidRows) {
      newErrors.faqRows = true;
      newHelperTexts.faqRows = 'At least one complete FAQ entry is required';
      isValid = false;
    }

    faqRows.forEach((row, index) => {
      if (!row.question.trim() || !row.answer.trim()) {
        newRowErrors[index] = true;
        isValid = false;
      } else {
        newRowErrors[index] = false;
      }
    });

    setErrors(newErrors);
    setHelperTexts(newHelperTexts);
    setRowErrors(newRowErrors);
    return isValid;
  }, [selectedProduct, operation, faqData, editID, faqRows]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    const validRows = faqRows.filter((row) => row.question.trim() && row.answer.trim());

    try {
      setOpenLoader(true);
      const payload = {
        ProductID: selectedProduct.ProductID,
        IsActive: faqHeaderStatus,
        CreatedBy: 5,
        ModifyedBy: 5,
      };

      if (operation === 'Add') {
        const headerId = await InsertFAQHeader(payload);
        if (!headerId) throw new Error('Header creation failed.');

        await Promise.all(
          validRows.map((row) =>
            InsertFAQDetail({ HeaderID: headerId, Question: row.question, Answer: row.answer, CreatedBy: 5 })
          )
        );

        setAlertType('success');
        setAlertMessage('FAQ saved successfully!');
      } else {
        await UpdateFAQHeader(editID, payload);
        await DeleteFAQDetailsByHeaderId(editID);

        await Promise.all(
          validRows.map((row) =>
            InsertFAQDetail({ HeaderID: editID, Question: row.question, Answer: row.answer, CreatedBy: 5 })
          )
        );

        setAlertType('success');
        setAlertMessage('FAQ updated successfully!');
      }

      setopenAlert(true);
      await getAllFAQ();
      handleClose();
    } catch (error) {
      console.error('Error saving FAQ:', error);
      setAlertType('error');
      setAlertMessage('Failed to save FAQ.');
      setopenAlert(true);
    } finally {
      setOpenLoader(false);
      setIsSubmitting(false);
    }
  };

  const handleAddOpen = useCallback(() => {
    setOpen(true);
    setOperation('Add');
    resetFields();
  }, [resetFields]);

  const handleEdit = useCallback(async (faq) => {
    setEditID(faq.HeaderID);
    setOperation('Edit');
    setFaqHeaderStatus(faq.IsActive || 'Y');
    setOpen(true);
    setOpenLoader(true);

    try {
      const productRes = await axios.instance.get(`/GetOneProduct/${faq.ProductID}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      const product = productRes.data && productRes.data[0] ? productRes.data[0] : null;
      setSelectedProduct(product);

      const detailRes = await axios.instance.get(`/GetFAQDetailsByHeaderId/${faq.HeaderID}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      const details = detailRes.data || [];
      const mappedRows = details.length
        ? details.map((d) => ({ question: d.Question, answer: d.Answer }))
        : [{ question: '', answer: '' }];
      setFaqRows(mappedRows);
      setRowErrors(mappedRows.map(() => false));
    } catch (error) {
      console.error('Error loading FAQ data:', error);
      setAlertType('error');
      setAlertMessage('Failed to load FAQ details.');
      setopenAlert(true);
    } finally {
      setOpenLoader(false);
    }
  }, []);

  const handleDelete = useCallback((faqId) => {
    setOpenDelete(true);
    setIdToDelete(faqId);
  }, []);

  const handleDeleteConfirmed = useCallback(async () => {
    try {
      setOpenLoader(true);
      await DeleteFAQDetailsByHeaderId(IdToDelete);
      await DeleteFAQHeader(IdToDelete);
      setOpenDelete(false);
      setAlertType('warning');
      setAlertMessage('FAQ Deleted Successfully!');
      setopenAlert(true);
      await getAllFAQ();
    } catch (error) {
      console.error('Error deleting FAQ:', error);
      setAlertType('error');
      setAlertMessage('Failed to delete FAQ.');
      setopenAlert(true);
    } finally {
      setOpenLoader(false);
    }
  }, [IdToDelete]);

  const handleCloseDelete = useCallback(() => {
    setOpenDelete(false);
  }, []);

  const handleCloseAlert = useCallback(() => {
    setopenAlert(false);
  }, []);

  const handleClose = useCallback(() => {
    resetFields();
    setOpen(false);
  }, [resetFields]);

  const handleFilterOpen = useCallback((event) => {
    setFilterAnchorEl(event.currentTarget);
  }, []);

  const handleFilterClose = useCallback(() => {
    setFilterAnchorEl(null);
  }, []);

  const filteredData = useMemo(() => {
    let filtered = faqData;

    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        Object.values(item).some((value) => typeof value === 'string' && value.toLowerCase().includes(searchLower))
      );
    }

    if (activeFilter && activeFilter.value !== 'all') {
      filtered = filtered.filter((item) => item.IsActive === activeFilter.value);
    } else {
      filtered = filtered.filter((item) => item.IsActive === 'Y');
    }

    if (productFilter && productFilter.value !== 'all') {
      filtered = filtered.filter((item) => item.ProductID === productFilter.value);
    }

    return filtered;
  }, [faqData, searchTerm, activeFilter, productFilter]);

  const clearAllFilters = useCallback(() => {
    setActiveFilter({ label: 'Active', value: 'Y' });
    setProductFilter(null);
    setSearchTerm('');
    handleFilterClose();
  }, [handleFilterClose]);

  const getActiveFilterCount = useMemo(() => {
    let count = 0;
    if (activeFilter && activeFilter.value !== 'all') count += 1;
    if (productFilter && productFilter.value !== 'all') count += 1;
    if (searchTerm) count += 1;
    return count;
  }, [activeFilter, productFilter, searchTerm]);

  const statusOptions = useMemo(
    () => [
      { label: 'All Status', value: 'all' },
      { label: 'Active', value: 'Y' },
      { label: 'Inactive', value: 'N' },
    ],
    []
  );

  const productOptions = useMemo(
    () => [
      { label: 'All Products', value: 'all' },
      ...productList.map((product) => ({ label: getProductDisplayText(product), value: product.ProductID })),
    ],
    [productList, getProductDisplayText]
  );

  const loadFaqDetails = useCallback(
    async (headerId) => {
      if (!headerId || faqDetailMap[headerId]) return;

      try {
        const res = await axios.instance.get(`/GetFAQDetailsByHeaderId/${headerId}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });

        setFaqDetailMap((prev) => ({
          ...prev,
          [headerId]: res.data || [],
        }));
      } catch (error) {
        console.error('Error fetching FAQ details:', error);
      }
    },
    [faqDetailMap]
  );

  const toggleFaqExpand = useCallback(
    async (headerId) => {
      const nextId = expandedFaqId === headerId ? null : headerId;
      setExpandedFaqId(nextId);

      if (nextId) {
        await loadFaqDetails(headerId);
      }
    },
    [expandedFaqId, loadFaqDetails]
  );

  // Render Grid View (Cards)
  const renderGridView = useCallback(
    () => (
      <Grid container spacing={3}>
        {filteredData.map((faq) => {
          const faqDetails = faqDetailMap[faq.HeaderID] || [];
          const isExpanded = expandedFaqId === faq.HeaderID;

          return (
            <Grid item xs={12} sm={6} md={4} key={faq.HeaderID}>
              <Fade in timeout={400}>
                <GridCard>
                  <CardContent sx={{ pb: 1 }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                          Product
                        </Typography>
                        <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 700, mt: 0.5 }}>
                          {faq.ProductDisplayName ||
                            getProductDisplayText({ ProductName: faq.ProductName, ShortCode: faq.ShortCode })}
                        </Typography>
                      </Box>
                      <Chip
                        label={faq.IsActive === 'Y' ? 'Active' : 'Inactive'}
                        color={faq.IsActive === 'Y' ? 'success' : 'error'}
                        size="small"
                      />
                    </Stack>
                    <Stack direction="row" spacing={1} sx={{ mt: 2, mb: 1 }} alignItems="center">
                      <Chip label={getQuestionCountText(faq.TotalQuestions)} size="small" variant="outlined" />
                    </Stack>
                  </CardContent>

                  <CardActions sx={{ justifyContent: 'space-between', px: 2, pt: 0 }}>
                    <Button
                      size="small"
                      onClick={() => toggleFaqExpand(faq.HeaderID)}
                      startIcon={
                        <ExpandMoreIcon
                          sx={{
                            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: '0.2s',
                          }}
                        />
                      }
                    >
                      {isExpanded ? 'Hide details' : 'View FAQ'}
                    </Button>
                    <Stack direction="row" spacing={0.5}>
                      <Tooltip title="Edit">
                        <IconButton size="small" onClick={() => handleEdit(faq)} sx={{ color: 'primary.main' }}>
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton
                          size="small"
                          onClick={() => handleDelete(faq.HeaderID)}
                          sx={{ color: 'error.main' }}
                        >
                          <DeleteForeverIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </CardActions>

                  <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                    <Divider />
                    <Box sx={{ p: 2, bgcolor: 'rgba(0,0,0,0.01)' }}>
                      {faqDetails.length === 0 ? (
                        <Typography variant="body2" color="text.secondary">
                          No questions available.
                        </Typography>
                      ) : (
                        <Stack spacing={1.5}>
                          {faqDetails.map((detail, index) => (
                            <Box
                              key={detail.DetailID || `${faq.HeaderID}-${index}`}
                              sx={{ p: 1.5, borderRadius: 1.5, bgcolor: 'white', border: '1px solid #eef2f7' }}
                            >
                              <Typography variant="subtitle2" fontWeight={700} color="primary.main" sx={{ mb: 0.5 }}>
                                Q{index + 1}: {detail.Question}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                              >
                                {detail.Answer}
                              </Typography>
                            </Box>
                          ))}
                        </Stack>
                      )}
                    </Box>
                  </Collapse>
                </GridCard>
              </Fade>
            </Grid>
          );
        })}
      </Grid>
    ),
    [
      filteredData,
      faqDetailMap,
      expandedFaqId,
      getProductDisplayText,
      getQuestionCountText,
      toggleFaqExpand,
      handleEdit,
      handleDelete,
    ]
  );

  // Render Full Row Card View (List View - Default)
  const renderListView = useCallback(
    () => (
      <Stack spacing={1.5}>
        {filteredData.map((faq, index) => {
          const faqDetails = faqDetailMap[faq.HeaderID] || [];
          const isExpanded = expandedFaqId === faq.HeaderID;

          return (
            <Fade in timeout={400} key={faq.HeaderID}>
              <FullRowCard elevation={0}>
                {/* Main Row Content */}
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  alignItems={{ xs: 'flex-start', sm: 'center' }}
                  spacing={{ xs: 1, sm: 2 }}
                >
                  {/* Serial Number */}
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, minWidth: 30 }}>
                    #{index + 1}
                  </Typography>

                  {/* Product Name with Questions */}
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
                      <Typography variant="body1" fontWeight={600} sx={{ fontSize: '0.95rem' }}>
                        {faq.ProductDisplayName ||
                          getProductDisplayText({ ProductName: faq.ProductName, ShortCode: faq.ShortCode })}
                      </Typography>
                      <Chip
                        label={getQuestionCountText(faq.TotalQuestions)}
                        size="small"
                        variant="outlined"
                        sx={{ fontWeight: 500, height: 22, fontSize: '0.65rem' }}
                      />
                    </Stack>
                  </Box>

                  {/* Status Chip */}
                  <Chip
                    icon={
                      faq.IsActive === 'Y' ? (
                        <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />
                      ) : (
                        <HighlightOffIcon sx={{ fontSize: 14 }} />
                      )
                    }
                    label={faq.IsActive === 'Y' ? 'Active' : 'Inactive'}
                    color={faq.IsActive === 'Y' ? 'success' : 'error'}
                    size="small"
                    sx={{ fontWeight: 600, height: 24, fontSize: '0.7rem', minWidth: 70 }}
                  />

                  {/* Actions */}
                  <Stack direction="row" spacing={0.5} alignItems="center">
                    <Button
                      size="small"
                      onClick={() => toggleFaqExpand(faq.HeaderID)}
                      endIcon={isExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                      sx={{ textTransform: 'none', fontSize: '0.75rem' }}
                    >
                      {isExpanded ? 'Hide' : 'View'}
                    </Button>

                    <Tooltip title="Edit">
                      <IconButton size="small" onClick={() => handleEdit(faq)} sx={{ color: 'primary.main', p: 0.5 }}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton
                        size="small"
                        onClick={() => handleDelete(faq.HeaderID)}
                        sx={{ color: 'error.main', p: 0.5 }}
                      >
                        <DeleteForeverIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </Stack>

                {/* Collapsible Q&A Section */}
                <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                  <Divider sx={{ my: 2 }} />
                  {faqDetails.length === 0 ? (
                    <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
                      No questions available.
                    </Typography>
                  ) : (
                    <Stack spacing={1.5}>
                      {faqDetails.map((detail, idx) => (
                        <Box
                          key={detail.DetailID || `${faq.HeaderID}-${idx}`}
                          sx={{
                            p: 1.5,
                            borderRadius: 2,
                            bgcolor: 'rgba(0,0,0,0.02)',
                            border: '1px solid #eef2f7',
                          }}
                        >
                          <Typography variant="subtitle2" fontWeight={700} color="primary.main" sx={{ mb: 0.5 }}>
                            Q{idx + 1}: {detail.Question}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                          >
                            {detail.Answer}
                          </Typography>
                        </Box>
                      ))}
                    </Stack>
                  )}
                </Collapse>
              </FullRowCard>
            </Fade>
          );
        })}
      </Stack>
    ),
    [
      filteredData,
      faqDetailMap,
      expandedFaqId,
      getProductDisplayText,
      getQuestionCountText,
      toggleFaqExpand,
      handleEdit,
      handleDelete,
    ]
  );

  return (
    <>
      <style>{`
        /* Sticky Dialog Styles */
        .sticky-dialog .MuiDialog-paper {
          display: flex;
          flex-direction: column;
          max-height: 95vh;
        }
        .sticky-dialog .MuiDialogContent-root {
          flex: 1 1 auto;
          overflow-y: auto;
          padding: 24px;
        }
        .sticky-dialog .MuiDialogActions-root {
          flex-shrink: 0;
        }
        .sticky-dialog .MuiDialogTitle-root {
          flex-shrink: 0;
        }
      `}</style>

      <Snackbar
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={Slide}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%', borderRadius: 2 }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth="xl" sx={{ pt: 3, pb: 4 }}>
        <HeaderPaper elevation={0}>
          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center">
            <Stack direction="row" alignItems="center" spacing={1}>
              <HelpOutlineIcon sx={{ color: 'white' }} />
              <Typography variant="h6" fontWeight={700} color="white" sx={{ letterSpacing: '0.02em' }}>
                FAQ Master
              </Typography>
            </Stack>
            <Typography variant="caption" color="rgba(255,255,255,0.7)">
              Total: {faqData.length} FAQ sets
            </Typography>
          </Stack>
        </HeaderPaper>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          alignItems={{ xs: 'stretch', md: 'center' }}
          sx={{ mb: 3 }}
        >
          <TextField
            placeholder="Search FAQs..."
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ flex: 1, minWidth: { md: 200 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchTerm('')}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Stack direction="row" spacing={1} alignItems="center">
            <Badge badgeContent={getActiveFilterCount} color="primary" invisible={getActiveFilterCount === 0}>
              <Button
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={handleFilterOpen}
                size="small"
                sx={{ borderRadius: 2 }}
              >
                Filters
              </Button>
            </Badge>

            <ToggleButtonGroup
              value={viewMode}
              exclusive
              onChange={(e, val) => val && setViewMode(val)}
              size="small"
              sx={{ '& .MuiToggleButton-root': { px: 1.5 } }}
            >
              <ToggleButton value="list">
                <ViewListIcon fontSize="small" />
              </ToggleButton>
              <ToggleButton value="grid">
                <ViewModuleIcon fontSize="small" />
              </ToggleButton>
            </ToggleButtonGroup>

            <Button
              variant="contained"
              startIcon={<PlaylistAddIcon />}
              onClick={handleAddOpen}
              sx={{ borderRadius: 2, boxShadow: 2 }}
            >
              Add FAQ
            </Button>
          </Stack>
        </Stack>

        <Popover
          open={Boolean(filterAnchorEl)}
          anchorEl={filterAnchorEl}
          onClose={handleFilterClose}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          PaperProps={{ sx: { maxWidth: 320, width: '100%', p: 2 } }}
        >
          <Typography variant="subtitle2" fontWeight={600} gutterBottom>
            Filter FAQ
          </Typography>

          <Stack spacing={2} sx={{ mt: 1 }}>
            <Autocomplete
              size="small"
              options={statusOptions}
              getOptionLabel={(option) => option.label}
              value={activeFilter}
              onChange={(e, newValue) => setActiveFilter(newValue)}
              renderInput={(params) => <TextField {...params} label="Status" size="small" />}
            />
            <Autocomplete
              size="small"
              options={productOptions}
              getOptionLabel={(option) => option.label}
              value={productFilter}
              onChange={(e, newValue) => setProductFilter(newValue)}
              renderInput={(params) => <TextField {...params} label="Product" size="small" />}
            />

            <Stack direction="row" spacing={1}>
              <Button variant="contained" size="small" fullWidth onClick={clearAllFilters} startIcon={<ClearIcon />}>
                Clear All
              </Button>
              <Button variant="outlined" size="small" fullWidth onClick={handleFilterClose}>
                Apply
              </Button>
            </Stack>
          </Stack>
        </Popover>

        {filteredData.length > 0 && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
            Showing {filteredData.length} FAQ set{filteredData.length !== 1 ? 's' : ''}
          </Typography>
        )}

        {filteredData.length === 0 ? (
          <Paper sx={{ textAlign: 'center', py: 6, borderRadius: 3 }}>
            <Typography variant="h6" color="text.secondary">
              No FAQ found
            </Typography>
            <Typography variant="body2" color="text.disabled">
              Try adjusting your filters or add a new FAQ
            </Typography>
          </Paper>
        ) : viewMode === 'list' ? (
          renderListView()
        ) : (
          renderGridView()
        )}
      </Container>

      {/* Add/Edit Dialog - Redesigned with Sticky Header & Footer */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        fullScreen={fullScreen}
        fullWidth
        className="sticky-dialog"
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: '95vh',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          {/* Sticky Header */}
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '1px solid #e8ecf0',
              bgcolor: '#fafbfc',
              py: 2,
              pr: 2,
              flexWrap: 'wrap',
              gap: 1,
              flexShrink: 0,
              position: 'sticky',
              top: 0,
              zIndex: 10,
            }}
          >
            <Typography variant="h6" fontWeight={600}>
              {`${operation} FAQ`}
            </Typography>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          {/* Scrollable Content */}
          <DialogContent
            sx={{
              p: 3,
              overflow: 'auto',
              flex: '1 1 auto',
              '&:first-of-type': { pt: 3 },
            }}
          >
            <Grid container spacing={2}>
              {/* Product Selection */}
              <Grid item xs={12} md={8}>
                <Autocomplete
                  options={getProductOptions()}
                  getOptionLabel={(option) => getProductDisplayText(option)}
                  value={selectedProduct}
                  onChange={(e, newValue) => {
                    setSelectedProduct(newValue);
                    setErrors((prev) => ({ ...prev, selectedProduct: false }));
                    setHelperTexts((prev) => ({ ...prev, selectedProduct: '' }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Product"
                      size="small"
                      error={errors.selectedProduct}
                      helperText={errors.selectedProduct ? helperTexts.selectedProduct : ''}
                      required
                      fullWidth
                      placeholder="Search for a product..."
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option?.ProductID === value?.ProductID}
                  disableClearable={operation === 'Edit'}
                />
              </Grid>

              {/* FAQ Entries Section */}
              <Grid item xs={12}>
                <Divider sx={{ my: 1 }}>
                  <Chip label="FAQ Entries" size="small" />
                </Divider>
              </Grid>

              <Grid item xs={12}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                  <Typography variant="caption" color="text.secondary">
                    Add questions and answers for this product
                  </Typography>
                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={addFaqRow}
                    size="small"
                    sx={{ borderRadius: 2 }}
                  >
                    Add Question
                  </Button>
                </Stack>
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ maxHeight: '45vh', overflow: 'auto', pr: 1 }}>
                  {faqRows.map((row, index) => (
                    <FAQRowItem
                      key={index}
                      row={row}
                      index={index}
                      onRowChange={handleFaqRowChange}
                      onRemove={removeFaqRow}
                      isRemovable={faqRows.length > 1}
                      rowError={rowErrors[index]}
                    />
                  ))}
                </Box>
                {errors.faqRows && (
                  <Typography variant="caption" color="error" sx={{ display: 'block', mt: 1 }}>
                    {helperTexts.faqRows}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </DialogContent>

          {/* Sticky Footer with Switch and Buttons */}
          <DialogActions
            sx={{
              p: 2,
              borderTop: '1px solid #e8ecf0',
              bgcolor: '#fafbfc',
              gap: 2,
              flexShrink: 0,
              position: 'sticky',
              bottom: 0,
              zIndex: 10,
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            {/* Left side - Status Switch */}
            <Stack direction="row" spacing={2} alignItems="center">
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Switch
                      checked={faqHeaderStatus === 'Y'}
                      onChange={(e) => setFaqHeaderStatus(e.target.checked ? 'Y' : 'N')}
                      color="success"
                      size="small"
                    />
                  }
                  label={
                    <Typography variant="body2" fontWeight={500}>
                      {faqHeaderStatus === 'Y' ? 'Active' : 'Inactive'}
                    </Typography>
                  }
                />
              </FormGroup>
            </Stack>

            {/* Right side - Action Buttons */}
            <Stack direction="row" spacing={1}>
              <Button variant="outlined" onClick={handleClose} size="medium">
                Cancel
              </Button>
              <Button type="submit" variant="contained" disabled={isSubmitting || !selectedProduct} size="medium">
                {isSubmitting ? 'Saving...' : operation === 'Add' ? 'Save FAQ' : 'Update FAQ'}
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog open={openDelete} onClose={handleCloseDelete} fullWidth maxWidth="xs">
        <DialogTitle sx={{ fontWeight: 600 }}>Delete FAQ?</DialogTitle>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button variant="outlined" onClick={handleCloseDelete}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleDeleteConfirmed}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Loader Dialog */}
      <Dialog open={openLoader} fullWidth>
        <LinearProgress />
      </Dialog>
    </>
  );
};

export default FAQMaster;
